import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared';

const routes: Routes = [
  {
    path: '', canActivate: [AuthGuard],
    loadChildren: () => import('./modules/account/account.module').then(mode => mode.AccountModule),
  },
  {
    path: 'dashboard', canActivate: [AuthGuard],
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(mode => mode.DashboardModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
